/**
 * Component: Product recommendations
 * Danish Modern L.A. Shopify Theme
 *
 * Fetches this section from Shopify's recommendations endpoint once it is
 * close to the viewport, then swaps in the rendered cards. Removes the
 * section if there is nothing to recommend.
 */

if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.children.length > 0 || !this.dataset.url) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return;
          this.observer.disconnect();
          this.load();
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    async load() {
      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) throw new Error(response.status);

        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = html.querySelector('product-recommendations');

        if (fresh && fresh.children.length > 0) {
          this.innerHTML = fresh.innerHTML;
        } else {
          this.closest('.shopify-section')?.remove();
        }
      } catch (error) {
        // Recommendations are optional; leave the page as it is.
        console.error('Product recommendations failed to load', error);
      }
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
